// biome-ignore lint/suspicious/noExplicitAny: any is allowed in typeguard functions
export function isForwardRefComponent(Component: any) {
  if (!Component) {
    return false;
  }
  return Component?.$$typeof === Symbol.for('react.forward_ref');
}

// This can be removed once https://nerdwallet.atlassian.net/browse/CARD-6093 is worked on and
// we remove usage of cloneElement.
// biome-ignore lint/suspicious/noExplicitAny: any is allowed in typeguard functions
export function warnOnDevIfCloneElementWillFail(child: any, componentName: string) {
  if (process.env.NODE_ENV !== 'production' && child?.$$typeof && child.type === undefined) {
    console.error(
      `[DEV ONLY] [${componentName}] cloneElement received a child with an undefined type. ` +
        'In dev mode, this happens when a server component passes JSX children to a client ' +
        "component that uses cloneElement (the RSC Flight serialization doesn't resolve the " +
        `element type in dev). Add 'use client' to the component that renders <${componentName}>. ` +
        'This does not affect production builds.',
    );
  }
}
